import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

const KEY = (pid: string) => ['projects', pid, 'offene-punkte'] as const;

export function useOffenePunkte(projectId: string | undefined) {
  return useQuery({
    queryKey: KEY(projectId ?? ''),
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/offene-punkte`),
    enabled: !!projectId,
  });
}

export function useCreateOffenerPunkt(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => apiClient.post(`/api/v1/projects/${pid}/offene-punkte`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useUpdateOffenerPunkt(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Record<string, unknown> }) =>
      apiClient.patch(`/api/v1/projects/${pid}/offene-punkte/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useDeleteOffenerPunkt(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/api/v1/projects/${pid}/offene-punkte/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}
